import { Component } from '@angular/core';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Utils } from '@app/_core/helper/Utils';
//import { InboundComponent } from 'src/app/pages/queue/inbound/inbound.component';
import { AgentLiveMoniterService } from '@app/_core/services/agent-live-moniter.service';
import { environment } from '@environments/environment';
import { BehaviorSubject } from 'rxjs';
import { ConfirmDialogComponent } from 'src/app/pages/common/confirm-dialog/confirm-dialog.component';
import { HubService } from 'src/app/pages/hubs/common/HubService';
import { CommunicationHub } from 'src/app/pages/hubs/tm/CommunicationHub';
import { TMHub } from 'src/app/pages/hubs/tm/TMHub';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { AgentLiveViewHub } from '../tm/AgentLiveViewHub';
declare let $: any;
let _userDetails: any;
let _hubService: any;
let _agentService: any;

// $.isFunction was removed in jQuery 4.0 but is required by jquery.signalR.
// Restore it as a polyfill so SignalR continues to work.
if (typeof $ !== 'undefined' && typeof $.isFunction === 'undefined') {
  $.isFunction = (obj: any) => typeof obj === 'function';
}
@Injectable({ providedIn: 'root' })
@Component({
  template: '',
})
export class HubManager {
  public hubManagerEvents: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    TMHubJoined: boolean = false;
  // @Output() CONNECTIONSTARTED: EventEmitter<any> = new EventEmitter<any>();
  //@Output() CONNECTIONACTIVE: EventEmitter<any> = new EventEmitter<any>();
  //@Output() CONNECTIONRESTARTING: EventEmitter<any> = new EventEmitter<any>();
  //@Output() CONNECTIONRESTARTED: EventEmitter<any> = new EventEmitter<any>();
  // @Output() CONNECTIONENDED: EventEmitter<any> = new EventEmitter<any>();
  // @Output() CONNECTIONLAUNCH: EventEmitter<any> = new EventEmitter<any>();
  //static CONNECTION_ACTIVE: string = 'qbrHubManagerConnectionActive';
  //static CONNECTION_STARTED: string = 'qbrHubManagerConnectionStarted';
  //static CONNECTION_RESTARTING: string = 'qbrHubManagerConnectionRestarting';
  //static CONNECTION_RESTARTED: string = 'qbrHubManagerConnectionRestarted';
  //static CONNECTION_ENDED: string = 'qbrHubManagerConnectionEnded';

  Hub_connection_Started: boolean = false;
  Hub_connection_Starting: boolean = false;

  constructor(
    private router: Router,
    private hubService: HubService,
      private agentliveview: AgentLiveMoniterService,
      private webStorageService: WebStorageService,
    private confirmDialogComponent: ConfirmDialogComponent
  ) {
    _hubService = hubService;
    _agentService = agentliveview;
    this.eAppWillLaunchHandler();
    //document.addEventListener('onDisconnect', () => {
    //    alert('testt');
    //});
    try {
      $.connection.hub.disconnected(() => {
        if ($.connection.hub.lastError) {
          console.log('HUB Disconnected due to the Reason: ' + $.connection.hub.lastError.message);
        }

        console.log('HUB Disconnected');
        this.Hub_connection_Started = false;
        this.Hub_connection_Starting = false;

        this.setHubManagerEvents({ eventName: 'CONNECTIONENDED', data: null });
          this.setTMHubJoinedStatus(false);
        this.start(this.hubService.getuserDetails());
      });
      $.connection.hub.reconnecting(() => {
        console.log('HUB Reconnecting');

        this.setHubManagerEvents({ eventName: 'CONNECTIONRESTARTING', data: null });
      });
      $.connection.hub.reconnected(() => {
        console.log('HUB Reconnected');
        this.Hub_connection_Started = false;
        this.Hub_connection_Starting = false;
          this.hubService.setTMHubJoinedStatus(false);
        this.setHubManagerEvents({ eventName: 'CONNECTIONSTARTED', data: _userDetails });
        this.setHubManagerEvents({ eventName: 'CONNECTIONACTIVE', data: null });
        // this.CONNECTIONSTARTED.emit(_userDetails);
        // this.CONNECTIONACTIVE.emit();
      });

      $.connection.hub.connectionSlow(() => {
        console.log('SignalR: Your Network Connection is slow..');
        //this.notifyUserOfConnectionProblem();
      });

      //this.CONNECTIONLAUNCH.subscribe(res => {
      //  this.eAppWillLaunchHandler();
      //});
    } catch (exception) {
      if (window.hasOwnProperty('console')) console.error(exception.message);
    }
  }

  setHubManagerEvents(value: any) {
    //console.log(value, 'Value');
    this.hubManagerEvents.next(value);
  }

  //gethubManagerEvents() {
  //  return this.hubManagerEvents;
  //}

    public start(userDetails) {
        return new Promise((resolve, reject) => {
    // To clear the local storage when the user logs off from URL '/'
   // console.log(window.location.href);
   // console.log(this.router.url);
    const clientAbbreviation = Utils.fetch('clientAbbreviation');
            if (!window.location.href.includes(clientAbbreviation) && localStorage.getItem('UserJustLoggedIn') == 'false') {
              localStorage.clear();
              sessionStorage.clear();
            }

            try {
              _userDetails = userDetails;
              this.hubService.setuserDetails(_userDetails);
              //if (!this.Hub_connection_Started && !this.Hub_connection_Starting) {
                this.Hub_connection_Starting = true;
                const session_ID = this.webStorageService.getItemFromSessionStorage("SessionID");
              //const sessionID: string = "a52dbe58-dc43-41ee-9f34-779cd72edc13";
              //const client: string = "HR1";
                $.connection.hub.qs = { "sessionID": session_ID, "client": clientAbbreviation };
             // console.log('localStorage.getItem ', localStorage.getItem('clientAbbreviation'));
                if (localStorage.getItem('clientAbbreviation') != null) {
                    if ($.connection.hub.state === 4) {
                        $.connection.hub.start().done(() => {
                            console.log('Hub Connection started', $.connection.hub);
                            console.log('Hub ConnectionID:' + $.connection.hub.id);
                            this.Hub_connection_Started = true;
                            this.Hub_connection_Starting = false;
                            //if (callback)
                            //    callback();
                            this.setHubManagerEvents({ eventName: 'CONNECTIONSTARTED', data: _userDetails });
                            this.setHubManagerEvents({ eventName: 'CONNECTIONACTIVE', data: null });

                            //$.connection.hub['CommunicationHub'].join(
                            //    _userDetails.find(i => i.key === 'ClientShortName').value,
                            //    'Telemarketing',
                            //    _userDetails.find(i => i.key === 'Username').value,
                            //    _userDetails.find(i => i.key === 'UserEmail').value,
                            //    _userDetails.find(i => i.key === 'UserID').value
                            //);

                            // this.CONNECTIONSTARTED.emit(_userDetails);
                            //this.CONNECTIONACTIVE.emit();
                            resolve(null);
                        });
                    }
                    else {
                        console.log('SignalR is active, calling start')
                    }

              } else {
                console.log('Company id empty, user logged off');
                this.eAppWillCloseHandler();
              }

              //}
            } catch (exception) {
              if (window.hasOwnProperty('console')) console.error(exception.message);
              }
        });
  }
  public notifyUserOfConnectionProblem() {
    this.confirmDialogComponent
      .confirmdialog('', 'SignalR: Your Network Connection is slow. Please Check your Internet Speed..', 'OK', '')
      .then(confirmed => {
        if (confirmed) {
        } else {
          //Reject
        }
      })
      .catch(() =>
        console.log(
          'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
        )
      );
  }

  public CallHubManager(userDetails) {
    
    try {
        this.setHubManagerEvents({ eventName: 'CONNECTIONSTARTED', data: _userDetails });
        this.setHubManagerEvents({ eventName: 'CONNECTIONACTIVE', data: null });
    } catch (e) {}
    }
    public CallHubManager1(userDetails) {
        //if (!this.Hub_connection_Started && !this.Hub_connection_Starting) {
        //    this.start(userDetails);
        // }
        try {
            if ($.connection.hub.state && $.connection.hub.state == 4) {
                //this.start(userDetails)
                this.start(userDetails).then(() => {
                    console.log('SignalR connection established successfully!');
                    // You can now interact with the hub, e.g., call server methods
                    // this.signalrService.invokeServerMethod('SendMessage', 'Hello from Angular!');
                })
                    .catch(err => console.error('Error starting SignalR connection:', err));
                console.log(
                    'CallHubManager called, connection.hub.state disconnected and hugmanager called to start' +
                    $.connection.hub.state
                );
            }
        } catch (e) { }
    }
    public SetUserDetails(userDetails) {
        _userDetails = userDetails;
        this.hubService.setuserDetails(_userDetails);
    }
  connectionStarted() {
    return this.Hub_connection_Started;
  }

  public eAppWillLaunchHandler = (): void => {
    try {
      // $.isFunction was removed in jQuery 4.0 but is required by jquery.signalR.
      // Restore it as a polyfill so SignalR continues to work.
      if (typeof $.isFunction === 'undefined') {
        $.isFunction = (obj: any) => typeof obj === 'function';
      }

      $.connection.hub.url = environment.apiUrl + 'signalr'; // 'https://tmapi.q-central.dev/signalr';
      console.log('Hub Connection launched');

      new TMHub(this); //TMHUB

      //new AgentLiveViewHub.AgentLiveViewHub();//AgentLiveViewHub
      //new ChatHub.ChatHub();//ChatHub

      new CommunicationHub(this, _hubService); //CommunicationHub
      new AgentLiveViewHub(this, _hubService, _agentService);
    } catch (exception) {
      if (window.hasOwnProperty('console')) console.error(exception.message);
    }
  };

  eAppWillCloseHandler = (): void => {
    this.Hub_connection_Started = false;
    this.Hub_connection_Starting = false;
    this.stop();
  };

  stop(): void {
    try {
      $.connection.hub.stop();
    } catch (exception) {
      if (window.hasOwnProperty('console')) console.error(exception.message);
    }
    }

    setTMHubJoinedStatus(value: boolean) {
        this.hubService.setTMHubJoinedStatus(value);
        this.TMHubJoined = value;
    }
    setIsHubStarted(value: boolean) {
        this.hubService.setIsHubStarted(value);
    }
    getTMHubJoinedStatus() {

        return this.TMHubJoined;
    }
}
